module.exports = ".custom-file-upload {\r\n  border: 1px solid var(--light-gray);\r\n  display: inline-block;\r\n  padding: 6px 12px;\r\n  cursor: pointer;\r\n  background: var(--primaryColor);\r\n  color: var(--white);\r\n  border-radius: 8px;\r\n  outline: none;\r\n}\r\n\r\n.pl-13 {\r\n  padding-left: 13px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/account/support-components/mail-document/mail-document.component.css
// module id = ./src/app/account/support-components/mail-document/mail-document.component.css
// module chunks = main